import { Link, useCanGoBack, useRouter } from "@tanstack/react-router";

import { Button, buttonVariants } from "@workspace/ui/components/button";
import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from "@workspace/ui/components/card";
import { cn } from "@workspace/ui/lib/utils";

export function NotFoundComponent() {
	const router = useRouter();
	const canGoBack = useCanGoBack();

	return (
		<div className="flex items-center justify-center min-h-screen bg-gray-50 dark:bg-gray-950 p-4">
			<Card className="w-full max-w-md text-center">
				<CardHeader>
					<CardTitle className="text-4xl font-bold text-gray-800 dark:text-gray-200">
						404 - Page Not Found
					</CardTitle>
					<CardDescription className="text-gray-600 dark:text-gray-400">
						The page you are looking for does not exist.
					</CardDescription>
				</CardHeader>
				<CardContent>
					{canGoBack ? (
						<Button onClick={() => router.history.back()} className={"w-full"}>
							Go back
						</Button>
					) : (
						<Link to="/" className={cn(buttonVariants(), "w-full")}>
							Go to Home
						</Link>
					)}
				</CardContent>
			</Card>
		</div>
	);
}
